module.exports = __webpack_public_path__ + "static/media/ranky-logo-text-blue.cab29d94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ranky-logo-text-blue.png
// module id = 123
// module chunks = 0